export interface BikeDetails {
  bikeId: string;
  name: string;
  brandName: string;
  imageUrl: string;
  displacement: string;
  transmissionType: string;
  mfgDate: string;
  kerbWeight: string;
  ridingRange: string;
  mileage: string;
  chargingTime: string;
  motorPower: string;
  speedLimit: string;
  timePenalty: number;
  distancePenalty: number;
  engineType: string;
  kmsLimit?: number;
  bootStorage?: string;
}

export interface DeliveryCharges {
  upto10: number;
  upto20: number;
}

export interface Delivery {
  accept: boolean;
  deliveryCharges: DeliveryCharges;
}

export const DELIVERY_CHARGE_TYPES = {
  UPTO10: 'upto10',
  UPTO20: 'upto20'
} as const;

// Delivery range constants
export const DELIVERY_RANGES = {
  TEN_KM: '10km',
  TWENTY_KM: '20km'
} as const;

export type DeliveryRangeType = typeof DELIVERY_RANGES[keyof typeof DELIVERY_RANGES];

export interface Pricing {
  securityDepositAmount: number;
  acceptPartialPayment: boolean;
  price: number;
  minPartialPayment: number;
}

export interface BookingPage {
  bikeDetails: BikeDetails;
  delivery: Delivery;
  pricing: Pricing;
  kmsLimit: number;
  tnc: string[];
  accessories: Accessory[];
  locationTimings: string;
  from?: string | Date;
  to?: string | Date;
}

export interface LoginDetails {
  phone: string;
  token: string;
}
export interface PickDropTime {
  pickup: string;
  dropOff: string;
}
export interface SelectedCity {
  name: string;
  imgUrl: string;
}

export interface CityDetails {
  name: string;
  _id: string;
}

export interface HomeProps {
  selectCity: string;
  citiesData:unknown;
}

export const navItems = [
  { label: "HOME", href: "/" },
  // { label: "BLOGS", href: "/blogs" },
  { label: "ABOUT", href: "/about-us" },
  { label: "CONTACT US", href: "/contact-us" },
  { label: "FAQ", href: "/faq" },
];

export interface Plan {
  disabled: boolean;
  price: number;
  kmLimit: number;
  weekendPrice?: {
    disabled: boolean;
    price: number;
    kmLimit: number;
  };
}

export interface Station {
  stationId: string;
  stationName: string;
  delivery: boolean;
  deliveryCharges: {
    upto10: number;
    upto20: number;
  };
  bikeId: string;
  mfgYear: string;
  distancePenalty: number;
  securityDepositAmount: number;
  price: number;
  limit: number;
  plans: {
    halfDay: Plan;
    oneDay: Plan;
    oneWeek: Plan;
    fifteenDays: Plan;
    oneMonth: Plan;
    threeMonths: Plan;
    sixMonths: Plan;
  };
  bikesRemainingCount?: number;
}

export interface Product {
  variantId: string;
  name: string;
  brandName: string;
  imageUrl: string;
  displacement: string;
  transmissionType: string;
  stations: Station[];
  minPrice: number;
  bikeId: string;
}

export interface BikeCompareData {
  _id: string;
  name: string;
  imageUrl: string;
  brandName: string;
  transmissionType: string;
  engineType: string;
  kerbWeight: string;
  displacement: string;
  mileage: string;
  ridingRange: string;
  chargingTime: string;
  motorPower: string;
}

export interface City {
  _id: string;
  name: string;
  disabled?: boolean;
  // Add other fields if needed
}

export interface Accessory {
  _id: string;
  imgUrl: string;
  name: string;
  price: string;
  id: string;
}

export interface BikeCompareResponse {
  bikeDetails: {
    bikeId: string;
    name: string;
    brandName: string;
    imageUrl: string;
    displacement: string;
    transmissionType: string;
    mfgDate: string;
    kerbWeight: string;
    ridingRange: string;
    mileage: string;
    chargingTime: string;
    motorPower: string;
    speedLimit: string;
    timePenalty: number;
    distancePenalty: number;
    engineType: string;
    bootStorage?: string;
  };
  delivery: {
    accept: boolean;
    deliveryCharges: {
      upto10: number;
      upto20: number;
    };
  };
  pricing: {
    securityDepositAmount: number;
    acceptPartialPayment: boolean;
    price: number;
    minPartialPayment: number;
  };
  kmsLimit: number;
  tnc: string[];
  locationTimings: string;
}
export interface ProfileData {
  name:string,
  mobile:string,
  email:string,
  _id:string
 }
 
export interface DataForRZP {
  profileData: ProfileData;
  orderId:string;
  amount:number;
  rzpId:string;
}

export const paymentType = ["Pay Full Amount", "Pay Partial Amount"];

export const PAYMENT_TYPES = {
  FULL: "Pay Full Amount",
  PARTIAL: "Pay Partial Amount",
} as const;

export interface DataForApiCall {
  userId: string;
  stationId: string;
  bikeId: string;
  accessories?: { id: string; qty: number }[];
  to: string | Date;
  from: string | Date;
  isPartial: boolean;
  deliveryInfo?: {
    address: string;
    deliveryCharge: string;
  };
}